import { useFile, useFiles, useWikis } from '~/utils/hooks/hooks';
import { useMobile, useMobileSearchOpen } from '~/utils/store';
import { Search } from '../Search/Search';

type Props = {
  wikiId: string;
};

export const SearchMobile = ({ wikiId }: Props) => {
  const isMobile = useMobile();
  const [mobileSearchOpen] = useMobileSearchOpen();
  const { data: wikis = [] } = useWikis();
  const { data: wiki } = useFile(wikiId, wikis, wikiId);
  const { files } = useFiles(wikiId);

  if (!isMobile || !mobileSearchOpen || !wiki) return null;

  return (
    <div style={{ maxWidth: 958, margin: '0 auto', width: '100%', marginTop: '1.5rem', marginBottom: 0 }}>
      <Search files={files} wiki={wiki} autoFocus noAnimation />
    </div>
  );
};
